import { Component, Input } from '@angular/core';
import { Events } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';




/**
 * Generated class for the Dashboard page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
  selector: 'ripeti_5',
  templateUrl: 'ripeti_5.html',

})

export class Ripeti_5Component {

  @Input('domanda') domanda: any;
  @Input('mq') mq: any;
  @Input('settingsmq') settingsmq: any;
  output: any;
  words: any = [];
  words_lento: any = [];
  indice = 0;
  risposte_conferma = [];
  showconferma: boolean = true;
  feed = '';
  showtime: boolean = true;
  testo_domanda:string = '';
  constructor(public events: Events,public translate: TranslateService) {


  }

  ngOnInit(): void {
    
    this.events.publish('start_tempo', this.domanda);
    if (this.settingsmq.typewriter == true) {
      var html = this.domanda['testo'];
      var div = document.createElement("div");
      div.setAttribute('style', "display:none");
      div.innerHTML = html;
      var text = div.textContent || div.innerText || "";

      //this.words = this.domanda['testo'].split(' ');
      this.words = text.split(' ');

      this.addword();
    }
    else{
      this.testo_domanda = this.domanda['testo'];
    }
    if (this.domanda.durataMinima != '0') {
      this.showtime = false;
    }

    this.events.subscribe('tempo_' + this.domanda.id, (tipotempo) => {
      if (tipotempo == 'minima')
        this.showtime = true;
      else if (tipotempo == 'massima')
        this.prosegui();
    });
  }
  addword() {
    setTimeout(() => {
      if (this.words[this.indice] != undefined) {
        this.words_lento.push(this.words[this.indice] + ' ');
        this.indice++;
        this.addword();
      }
    }, 302);
  }
  prosegui() {
    this.events.publish('stop_tempo_parziale', this.domanda);
    this.events.publish('stop_tempo', this.domanda);
    this.showconferma = false;
    this.events.publish('ripeti', this.domanda, this.risposte_conferma);
  }
  // conferma(tempo?){
  //   this.events.publish('stop_tempo', this.domanda);
  //   this.showconferma = false;
  //   if(this.settingsmq['istest'])
  //     this.prosegui();
  // }
}



// WEBPACK FOOTER //
// ./src/pages/msteps/ripeti_5.ts